import { BiteServiceName } from '@biteinc/enums';
// Maitred sets the principal from the verified token; a client value is dropped.
export const servicePrincipalSchema = {
    type: 'object',
    isPermanent: true,
    isReadOnly: true,
    fields: {
        kind: { type: 'stringEnum', enum: { Service: 'Service' }, required: true },
        name: { type: 'stringEnum', enum: BiteServiceName, required: true },
    },
};
//# sourceMappingURL=service_principal_schema.js.map